module.exports = __webpack_public_path__ + "static/media/couches-16.8744a0d6.jpg";